module.exports = __webpack_public_path__ + "static/media/4.MCB's.aa8e6daf.jpg";